export default {
      id: "icon-oda-telefonu-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-oda-telefonu",
      toString: function () {
        return this.url;
      }
    }